import _defineProperty2 from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './RangeFilter.css';
import React from 'react';
import { tealiumClickFunc, tealiumMergeClickData } from "../../utils/tealium";
import { get } from "../../utils";
import { DropdownFilterWrapper } from "./DropdownFilterWrapper";
import addQueryString, { deleteQueryString } from "./index";
import { useHistory } from "react-router-dom";
import { qsToObject } from "../../utils/querystring";
/*eslint-disable */

var createRanges = function createRanges(annualFeeRangeObject) {
  var step = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50000;
  var isMultiSelect = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var annualFeeRangeArr = Object.keys(annualFeeRangeObject);
  return annualFeeRangeArr.map(function (annualFeeRange, ind) {
    var index = +annualFeeRange;
    var count = annualFeeRangeObject[annualFeeRange];
    // (N, N+50k-1)
    var from = "".concat(index * step);
    var to = "".concat(index * step + step - 1);
    var title = "".concat(from, " - ").concat(to);
    return {
      id: "range".concat(index),
      title: title,
      range: index,
      count: count
    };
  });
};
var createRangesCompress = function createRangesCompress() {
  var rangeObject = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var step = arguments.length > 1 ? arguments[1] : undefined;
  var rangeList = Object.keys(rangeObject);
  var head = rangeList.filter(function (range) {
    return +range <= 9;
  });
  var tail = rangeList.filter(function (range) {
    return +range > 9;
  });
  var headMap = head.map(function (range, ind) {
    var index = +range;
    var count = rangeObject[range];
    var from = "".concat(index * step + (index ? 1 : 0));
    var to = "".concat(index * step + step);
    var title = "".concat(from, " - ").concat(to);
    return {
      id: "range".concat(index),
      title: title,
      range: index,
      count: count
    };
  });
  var tailOption = {
    id: "range_tail",
    title: '1000+',
    range: 10,
    count: tail.reduce(function (acc, next) {
      return acc + rangeObject[next];
    }, 0)
  };
  if (tailOption.count) {
    return headMap.concat([tailOption]);
  }
  return headMap;
};
var RangeFilter = function RangeFilter(_ref) {
  var fields = _ref.fields,
    showLabel = _ref.showLabel,
    resultsLabel = _ref.resultsLabel,
    clearAllLabel = _ref.clearAllLabel,
    _ref$facetsStats = _ref.facetsStats,
    facetsStats = _ref$facetsStats === void 0 ? {} : _ref$facetsStats,
    facets = _ref.facets,
    queryString = _ref.queryString,
    nbHits = _ref.nbHits,
    setFilter = _ref.setFilter,
    facetsName = _ref.facetsName,
    indexDropDown = _ref.indexDropDown,
    firstQuery = _ref.firstQuery,
    firstFilter = _ref.firstFilter,
    wrapperToggle = _ref.wrapperToggle,
    defaultFacets = _ref.defaultFacets,
    setSubpanelLabel = _ref.setSubpanelLabel,
    clearAlllFilters = _ref.clearAlllFilters,
    _ref$hits = _ref.hits,
    hits = _ref$hits === void 0 ? [] : _ref$hits,
    _ref$isMultiSelect = _ref.isMultiSelect,
    isMultiSelect = _ref$isMultiSelect === void 0 ? false : _ref$isMultiSelect,
    analytics = _ref.analytics,
    setStartPage = _ref.setStartPage,
    getFilterValue = _ref.getFilterValue,
    _ref$columnsClass = _ref.columnsClass,
    columnsClass = _ref$columnsClass === void 0 ? 'col-md-4' : _ref$columnsClass;
  var history = useHistory();
  var checkboxes = /*#__PURE__*/React.createRef();
  var filterName = get(fields, 'name');
  var _React$useState = React.useState([]),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    ranges = _React$useState2[0],
    setRanges = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isOpen = _React$useState4[0],
    setIsOpen = _React$useState4[1];
  var _React$useState5 = React.useState({}),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    selectedRange = _React$useState6[0],
    setSelectedRange = _React$useState6[1];
  var _React$useState7 = React.useState(''),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    date = _React$useState8[0],
    setdate = _React$useState8[1];
  var label = get(fields, 'title.jss.value');
  var filterType = get(fields, 'fieldNameItem.item.fieldName.value');
  var _React$useState9 = React.useState(label),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    selected = _React$useState10[0],
    setSelected = _React$useState10[1];
  React.useEffect(function () {
    if (queryString === 'maxDelegates') {
      if (firstFilter === true) {
        setRanges(createRangesCompress(defaultFacets, 100));
      } else {}
      if (filterType !== firstQuery && "".concat(filterType, "RangeIndex") !== firstQuery) {
        setRanges(createRangesCompress(facets, 100));
      }
    }
    if (facets) {
      if (queryString !== 'maxDelegates') {
        setRanges(createRanges(facets, 50000, isMultiSelect));
      }
    }
  }, [facets, defaultFacets]);
  React.useEffect(function () {
    if (typeof window !== "undefined") {
      var urlParams = qsToObject(window.location.href);
      var anualFeeFilter = urlParams['universityPrograms.programs.anualFee'];
      if (anualFeeFilter) {
        var splitedRanges = anualFeeFilter.split('OR');
        var display = [];
        if (splitedRanges.length) {
          var state = {};
          display = splitedRanges.map(function (currentValue) {
            var _currentValue$trim$sp = currentValue.trim().split(':'),
              _currentValue$trim$sp2 = _slicedToArray(_currentValue$trim$sp, 2),
              range = _currentValue$trim$sp2[1];
            var rangeNmb = +range.replace(/\D/g, '');
            var _ref2 = ranges.find(function (_ref3) {
                var range = _ref3.range;
                return range === rangeNmb;
              }) || '',
              title = _ref2.title;
            state[title] = true;
            return title;
          });
          setSelected(display.join(', '));
          setSelectedRange(state);
        }
      }
    }
  }, [selected]);
  React.useEffect(function () {
    if (Object.keys(selectedRange).length != 0) {
      submitFilter(false, false);
    }
  }, [selectedRange]);
  var onChangeHandler = function onChangeHandler(_ref4) {
    var target = _ref4.target;
    var currentFacets = defaultFacets || facets;
    var countOfHits = 0;
    var tmpVal = _objectSpread(_objectSpread({}, selectedRange), {}, _defineProperty2({}, target.value, target.checked));
    isMultiSelect ? setSelectedRange(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, _defineProperty2({}, target.value, target.checked));
    }) : setSelectedRange(function () {
      return _defineProperty2({}, target.value, target.checked);
    });
    for (var range in tmpVal) {
      var itemRValue = tmpVal[range];
      if (itemRValue) {
        for (var itemFacet in currentFacets) {
          var value = currentFacets[itemFacet];
          var _range$split = range.split(' - '),
            _range$split2 = _slicedToArray(_range$split, 2),
            stRange = _range$split2[0],
            endRange = _range$split2[1];
          if (+itemFacet >= +stRange && +itemFacet <= +endRange) {
            countOfHits += value;
          }
        }
      }
    }

    // submitFilter(false);
  };
  var clearFilter = function clearFilter(e) {
    setSelected(label);
    setdate('');
    setFilter();
    if (setStartPage) {
      setStartPage(true);
    }
    wrapperToggle(true, false);
    deleteQueryString(queryString, history);
    setSelectedRange({});
    if (typeof checkboxes !== "undefined" && checkboxes.current) {
      var checkboxesArray = checkboxes.current.querySelectorAll('.input-choice');
      for (var i = 0; i <= checkboxesArray.length - 1; i++) {
        checkboxesArray[i].checked = false;
      }
    }
    setIsOpen(false);
    getFilterValue && getFilterValue(fields.name, facetsName, null);
    if (e) {
      e.stopPropagation();
    }
  };
  React.useEffect(function () {
    if (clearAlllFilters) {
      clearFilter();
    }
  }, [clearAlllFilters]);
  var submitFilter = function submitFilter(closeFilter) {
    var toggleWrapper = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (toggleWrapper) {
      wrapperToggle(true, closeFilter);
    }
    tealiumClickFunc(tealiumMergeClickData(analytics.filterShowResultsAnalytics, analytics.params));
    var filterArr = [];
    var labelDisplay = [];
    Object.keys(selectedRange).forEach(function (key) {
      if (selectedRange[key]) {
        isMultiSelect ? labelDisplay.push(key) : labelDisplay[0] = key;
        var curr = ranges.find(function () {
          var range = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          return range.title === key;
        });
        if (isMultiSelect) {
          filterArr.push("".concat(facetsName, ":").concat(curr.range));
        } else {
          if (queryString === 'maxDelegates') {
            filterArr[0] = curr.range;
          } else {
            filterArr[0] = "".concat(facetsName, ":").concat(curr.range);
          }
        }
      }
    });
    var filterString = filterArr.join('+OR+');
    setSelected(filterArr.length ? labelDisplay.join(', ') : label);
    getFilterValue && getFilterValue(fields.name, facetsName, filterString);
    setdate(filterString);
    filterArr.length ? addQueryString(queryString, filterString, history) : deleteQueryString(queryString, history);
    setFilter(date);
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    columnsClass: columnsClass
  }, /*#__PURE__*/React.createElement(DropdownFilterWrapper, {
    label: selected,
    defaultLabel: label,
    showLabel: showLabel,
    resultsLabel: resultsLabel,
    open: [isOpen, setIsOpen],
    setStartPage: setStartPage,
    applyFn: function applyFn(closeDropdwn) {
      submitFilter(true);
      closeDropdwn && closeDropdwn();
    }
  }, /*#__PURE__*/React.createElement("ul", {
    className: "range-list range-filter",
    onChange: onChangeHandler,
    ref: checkboxes
  }, /*#__PURE__*/React.createElement("li", {
    className: 'fp__inner-cb'
  }, /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("button", {
    className: "body-medium fp__inner-clear cursor-pointer btn--reset",
    onClick: function onClick(e) {
      clearFilter(e);
      tealiumClickFunc(tealiumMergeClickData(analytics.filterClearAllDateAnalytics, analytics.params));
    },
    onKeyPress: function onKeyPress(e) {
      if (e.which === 13) {
        e.preventDefault();
        clearFilter(e);
        tealiumClickFunc(tealiumMergeClickData(analytics.filterClearAllDateAnalytics, analytics.params));
      }
    }
  }, clearAllLabel)), ranges.map(function (range, index) {
    if (!range) {
      return null;
    }
    return /*#__PURE__*/React.createElement("li", {
      key: range.id,
      className: "range-item"
    }, /*#__PURE__*/React.createElement("label", {
      className: "fp__inner-label",
      htmlFor: range.id
    }, /*#__PURE__*/React.createElement("input", {
      className: "input-choice ".concat(isMultiSelect ? 'fp__checkbox' : 'fp__radio'),
      name: "annual-fee",
      defaultChecked: selectedRange[range.title],
      type: isMultiSelect ? 'checkbox' : 'radio',
      id: range.id,
      value: range.title,
      onChange: function onChange() {
        tealiumClickFunc(tealiumMergeClickData(analytics.filterAnalytics, analytics.params), "".concat(filterName, ": ").concat(range.title));
      }
    }), /*#__PURE__*/React.createElement("span", {
      className: "fp__inner-label-text"
    }, "".concat(range.title, " ").concat(range.count ? "(".concat(range.count, ")") : '')), /*#__PURE__*/React.createElement("span", {
      className: "fp__inner-label-bg"
    })));
  }))));
};
var StyledWrapper = function StyledWrapper(_ref6) {
  var children = _ref6.children,
    columnsClass = _ref6.columnsClass;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(columnsClass)
  }, children);
};

// export default DropDown;
export default RangeFilter;
var commonStyles = "cd2w092";
/*eslint-disable */